// @core/api/endpoints/apikey/list_permissions.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListPermissionsResponse,
} from '../../../types/apikey';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/apikey';

/**
 * List available permissions
 * Returns all available permission sections and their actions for building API key permission matrices. Each section maps to an OpenFGA object type.
 * @public This endpoint does not require authentication
 */
export async function ListPermissions(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListPermissionsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/api-keys/permissions`;
  const requestOptions = { ...options, skipAuth: true };
  return client.get<ListPermissionsResponse>(requestPath, { ...requestOptions, params });
}
